/* global angular */

angular.module('AemTransparentAccount')
  .factory('pageWrapperDataservice', pageWrapperDataservice)

pageWrapperDataservice.$inject = []

function pageWrapperDataservice () {
  function getPage (arr, pageSize, pageNumber) {
    var items = arr.slice(pageNumber * pageSize, pageNumber * pageSize + pageSize)
    return {
      items: items,
      pageNumber: pageNumber,
      pageCount: Math.ceil(arr.length / pageSize),
      pageSize: items.length,
      totalCount: arr.length
    }
  }

  return {
    getPage: getPage
  }
}
